// Database işlemeleri yapılacak ve dönen datanın state e geçmesi için mutation a gönderilecek
import sendReq from '@/utils/request'

export const login = async ({ commit }, data) => {
    commit('userLoading', true);
    let res;
    res = await sendReq("post","login", data)
    commit('login', res);
    commit('userLoading', false);
}

export const user_add = async ({ commit }, data) => {
   commit('userLoading', true);
   let res;
   res = await sendReq("post","system/users", data)
   commit('userStatus', res.data);
   commit('userLoading', false);
}

export const user_list = async ({ commit }, data) => {
    commit('userLoading', true);
    let res;
    res = await sendReq("get","system/users", data)
    commit('getUser', res.data);
    commit('userLoading', false);
 }

 export const users_list = async ({ commit }, data) => {
   commit('userLoading', true);
   let res;
   res = await sendReq("get","system/users", data)
   commit('getUser', res.data);
   commit('userLoading', false);
}

 export const changePassword = async ({ commit }, data) => {
    commit('userLoading', true);
    let res;
    res = await sendReq("post","system/users/"+data.user_id+"/changepassword", data)
    commit('userStatus', res.data);
    commit('userLoading', false);
 }

 export const changeDefaultPassword = async ({ commit }, data) => {
   commit('userLoading', true);
   let res;
   res = await sendReq("post","system/changepassword", data)
   commit('userStatus', res.data);
   commit('userLoading', false);
}

 export const listUserMenu = async ({ commit }, data) => {
   commit('userLoading', true);
   let res;
   res = await sendReq("get","system/menus", data)
   commit('getUserMenu', res.data);
   commit('userLoading', false);
}

export const authgrp_list = async ({ commit }, data) => {
   commit('userLoading', true);
   let res;
   res = await sendReq("get","system/authorites", data)
   commit('getAuth', res.data);
   commit('userLoading', false);
}

export const auth_add = async ({ commit }, data) => {
   commit('userLoading', true);
   let res;
   res = await sendReq("post","system/authorites", data)
   commit('userStatus', res.data);
   commit('userLoading', false);
}

export const usertype_list = async ({ commit }, data) => {
   commit('userLoading', true);
   let res;
   res = await sendReq("get","usertypes", data)
   commit('getUserType', res.data);
   commit('userLoading', false);
}
export const getLogs = async ({ commit }, data) => {
   commit('userLoading', true);
   let res;
   res = await sendReq("get","system/audits", data)
   commit('getLogs', res.data);
   commit('userLoading', false);
}
export const userSetState = async ({commit}, data) => {
   commit('userLoading', true);
   let res;
   res = await sendReq("put","system/users/"+data.userId+"/state", data)
   commit('userLoading', false);
}
export const deleteUser = async ({commit}, data) => {
   commit('userLoading', true);
   let res;
   res = await sendReq("delete","system/users/"+data.id, data)
   commit('userLoading', false);
}

export const getUserDetail = async ({ commit }, data) => {
   commit('userLoading', true);
   let res;
   res = await sendReq("get","system/users/"+data.id, data)
   commit('userDetail', res.data);
   commit('userLoading', false);
}

export const user_edit = async ({commit}, data) => {
   commit('userLoading', true);
   let res;
   res = await sendReq("put","system/users/"+data.id, data)
   commit('userStatus', res.data);
   commit('userLoading', false);
}

export const listAuthCasbin = async ({ commit }, data) => {
   commit('userLoading', true);
   let res;
   res = await sendReq("get","system/apis", data)
   commit('authCasbin', res.data);
   commit('userLoading', false);
}

export const listAuthsCasbin = async ({ commit }, data) => {
   commit('userLoading', true);
   let res;
   res = await sendReq("get","/system/authorites/"+data+"/casbin", data)
   commit('authsCasbin', res.data);
   commit('userLoading', false);
}
export const addAuthCasbin = async ({ commit }, data) => {
   commit('userLoading', true);
   let res;
   res = await sendReq("post","system/authorites/"+data.auth+"/casbin", data.data)
   commit('userStatus', res.data);
   commit('userLoading', false);
}

export const removeAuthCasbin = async ({ commit }, data) => {
   commit('userLoading', true);
   let res;
   res = await sendReq("delete","system/authorites/"+data.auth+"/casbin", data.data)
   commit('userStatus', res.data);
   commit('userLoading', false);
}

export const listAuthMenu = async ({ commit }, data) => {
   commit('userLoading', true);
   let res;
   //res = await sendReq("get","system/authorites/"+data+"/menus")
   //Ömer endpointi değitirdi 1 Şubat 2023
   res = await sendReq("get","user/menus")

   commit('getAuthMenu', res.data);
   commit('userLoading', false);
}

export const addAuthMenus = async ({ commit }, data) => {
   commit('userLoading', true);
   let res;
   res = await sendReq("post","system/authorites/"+data.auth+"/menus", data)
   commit('userLoading', false);
}

export const removeAuthMenus = async ({ commit }, data) => {
   commit('userLoading', true);
   let res;
   res = await sendReq("delete","system/authorites/"+data.auth+"/menus", data)
   commit('userLoading', false);
}
export const getCustomWidgets = async ({ commit }, data) => {
   commit('userLoading', true);
   let res;
   res = await sendReq("get","users/"+data.user_id+"/widgets")
   commit('widgets', res.data);
   commit('userLoading', false);
}
export const getWidgetValue = async ({ commit }, data) => {
   //commit('userLoading', true);
   let res;
   res = await sendReq("get",data.url)
   console.log({res: res.data, key: data.key})
   commit('widgetVal', {res: res.data, key: data.key});
   //commit('userLoading', false);
}



// WEBPACK FOOTER //
// ./src/store/modules/Users/Actions.js